import httpClient from 'modules/http-client'
import { EnvironmentVariables } from 'models/environment';
import env from 'modules/env/env';

export class TokenApi {
  getTokenByCode(scope: string, code: string) {
    let formData = new URLSearchParams();
    formData.append('client_id', env(EnvironmentVariables.clientId)!);
    formData.append('client_secret', env(EnvironmentVariables.clientSecret)!);
    formData.append('grant_type', 'authorization_code');
    formData.append('code', code);
    formData.append('redirect_uri', env(EnvironmentVariables.host)! + 'delete');
    
    return httpClient.post('/connect/token', formData);
  }

  getTokenByRefreshToken(scope: string, refreshToken: string) {
    let formData = new URLSearchParams();
    formData.append('client_id', env(EnvironmentVariables.clientId)!);
    formData.append('client_secret', env(EnvironmentVariables.clientSecret)!);
    formData.append('grant_type', 'refresh_token');
    formData.append('refresh_token', refreshToken);
    return httpClient.post('/connect/token', formData);
  }
}
